
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referio",
      function () {
        return require("private-next-pages/referio/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referio"])
      });
    }
  